import React from 'react';
import { Spin } from 'antd';

import { Container, Logo, LogoWrapper, LoadingIcon } from './style';

const SplashScreen = () => (
  <Container>
    <LogoWrapper>
      <Logo alt="Glassnode" src="/images/glassnode-studio.svg" />
    </LogoWrapper>
    <Spin indicator={<LoadingIcon />} size="large" />
  </Container>
);

export default SplashScreen;
